<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>David Che Kwok Wong has a Master Degree of Education and a Master Degree of Development Management. He enjoys spending most of his time working among ordinary people. He loves listening and associating with people, a great privilege to be called their friend. He loves travelling and keeping his journal with him at all times.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2e9fab98